import { render, staticRenderFns } from "./v80o1020MakePop2.vue?vue&type=template&id=db1d2f48&scoped=true"
import script from "./v80o1020MakePop2.vue?vue&type=script&lang=js"
export * from "./v80o1020MakePop2.vue?vue&type=script&lang=js"
import style0 from "./v80o1020MakePop2.vue?vue&type=style&index=0&id=db1d2f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1d2f48",
  null
  
)

export default component.exports